import LearningDebugPanel from './LearningDebugPanel';

export default LearningDebugPanel; 